import React from 'react';
import { bookData } from '../data/mockData';
import { Users, GraduationCap, TrendingUp, Target } from 'lucide-react';

const icons = [GraduationCap, Users, TrendingUp, Target];

const TargetAudienceSection = () => {
  return (
    <section id="target-audience" className="py-24 lg:py-32 bg-[#302f2c]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="mb-6 inline-block">
            <span className="caption text-[#d9fb06] bg-[#3f4816] px-4 py-2 rounded-full">
              ¿PARA QUIÉN ES ESTE LIBRO?
            </span>
          </div>
          
          <h2 className="heading-2 text-[#d9fb06] mb-6">
            Diseñado para Entrenadores que Quieren Destacar
          </h2>
          
          <p className="body-medium text-[#888680]">
            Si estás comenzando tu carrera como entrenador de fútbol o buscas 
            profesionalizar tu perfil, este libro es tu guía definitiva.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {bookData.targetAudience.map((audience, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="team-card bg-[#1a1c1b] border border-[#3f4816] rounded-lg p-8 hover:bg-[#3f4816] transition-all duration-300 group"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-full bg-[#3f4816] group-hover:bg-[#d9fb06] flex items-center justify-center transition-colors duration-300">
                      <Icon className="text-[#d9fb06] group-hover:text-[#1a1c1b]" size={28} />
                    </div>
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="heading-5 text-[#d9fb06] mb-3">
                      {audience.title}
                    </h3>
                    <p className="body-small text-[#888680] group-hover:text-[#dfddd6] transition-colors">
                      {audience.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Box */}
        <div className="mt-16 bg-[#1a1c1b] border-2 border-[#d9fb06] rounded-lg p-8 lg:p-12 text-center">
          <h3 className="heading-4 text-[#d9fb06] mb-4">
            ¿Te identificas con alguno de estos perfiles?
          </h3>
          <p className="body-medium text-[#888680] mb-6 max-w-2xl mx-auto">
            Este libro te dará las herramientas, estrategias y metodologías 
            probadas para construir una marca personal sólida desde el inicio de tu carrera.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection;
